import { Assigned, OperationFilter } from '../../services/types/Operation';
import { User } from '../../services/types/User';
import Role from '../../types/role';
import FilterConfig from './FilterConfig';
import { getColumnConfigs, getInitState } from './functions';
import { safeFind } from '../../shared/misc/utils';

class OperationsSession {
  filterConfigs: FilterConfig[];

  isOperRole: boolean;

  currentFilter: OperationFilter;

  getConfig = (filter: OperationFilter) => {
    const conditions = (x: FilterConfig) =>
      x.queryGroup === filter.queryGroup &&
      x.assigned === filter.assigned &&
      x.subqueryType === filter.subqueryType;
    return safeFind(this.filterConfigs, conditions);
  };

  getHideColumns = (filter: OperationFilter) => this.getConfig(filter).hideColumns;

  getRemoveColumns = (filter: OperationFilter) => this.getConfig(filter).removeColumns;

  setOrder = (filter: OperationFilter) => {
    const config = this.getConfig(filter);
    config.sortField = filter.sortField;
    config.sortDescending = filter.sortDescending;
  };

  setColumns = (filter: OperationFilter) => {
    const config = this.getConfig(filter);
    config.hideColumns = filter.hideColumns;
    config.removeColumns = filter.removeColumns;
  };

  setFilter = (filter: OperationFilter) => {
    this.currentFilter = filter;
  };

  constructor(user: User) {
    this.filterConfigs = getColumnConfigs();
    this.isOperRole = [Role.Specialist, Role.GroupHead].includes(user.roleCode);
    this.currentFilter = getInitState(
      user.roleCode,
      user.roleCode === Role.GroupHead || user.secondRoleCode === Role.GroupHead
        ? Assigned.MyOp
        : Assigned.AllOp,
      this.getHideColumns,
      this.getRemoveColumns
    );
  }
}

export default OperationsSession;
